import { useState, useCallback, Fragment } from 'react'
import UploaderContext from './UploaderContext'
import UploadDialog from './UploaderDialog'
import { UploadOptions, UploadType } from './types'

const DEFAULT_OPTIONS: UploadOptions = {
  dialogProps: {},
  backDropClose: false,
  type: UploadType.PROFILE,
  accept: {
    'image/jpeg': ['.jpeg', '.png', '.webp'],
  },
  maxSize: 10 * 1024 * 1024,
}

const buildOptions = (
  defaultOptions: UploadOptions,
  options: UploadOptions
): UploadOptions => {
  return {
    ...defaultOptions,
    ...options,
  }
}

const UploaderProvider = ({ children }: any) => {
  const [options, setOptions] = useState<UploadOptions>({
    ...DEFAULT_OPTIONS,
  })
  const [resolveReject, setResolveReject] = useState<any>([])
  const [resolve, reject] = resolveReject

  const confirm = useCallback((options: UploadOptions): Promise<void> => {
    return new Promise((resolve, reject) => {
      setOptions(buildOptions(DEFAULT_OPTIONS, options))
      setResolveReject([resolve, reject])
    })
  }, [])

  const handleClose = useCallback(() => {
    setResolveReject([])
  }, [])

  const handleCancel = useCallback(() => {
    if (reject) {
      reject()
      handleClose()
    }
  }, [reject, handleClose])

  const handleConfirm = useCallback(
    (res: any) => {
      if (resolve) {
        resolve(res)
        handleClose()
      }
    },
    [resolve, handleClose]
  )

  return (
    <Fragment>
      <UploaderContext.Provider value={confirm}>
        {children}
      </UploaderContext.Provider>
      <UploadDialog
        open={resolveReject.length === 2}
        options={options}
        onClose={() => {
          handleClose()
        }}
        onCancel={handleCancel}
        onConfirm={handleConfirm}
        replaceUri={options.replaceUri}
      />
    </Fragment>
  )
}

export default UploaderProvider
